import StatusPill from "../components/StatusPill";
import { categoryMeta, groupKey, label, timeAgo } from "./activityMeta";

function severityType(severity) {
  if (severity === "danger") return "danger";
  if (severity === "warning") return "warning";
  if (severity === "success") return "success";
  return "info";
}

function ActivityRow({ activity, onOpen }) {
  const meta = categoryMeta[activity.category] || categoryMeta.system;
  const Icon = meta.icon;

  return (
    <button
      type="button"
      className={`activity-row activity-row--${activity.severity}`}
      onClick={() => onOpen(activity)}
    >
      <span className="activity-row__icon"><Icon size={18} /></span>
      <span className="activity-row__body">
        <strong>{activity.title}</strong>
        <p>{activity.description || `${activity.source_label || "A record"} was updated.`}</p>
        <footer>
          <StatusPill status={activity.category} label={activity.category_label || label(activity.category)} type="neutral" size="sm" />
          <StatusPill status={activity.severity} label={activity.severity_label || label(activity.severity)} type={severityType(activity.severity)} size="sm" />
          <span>{activity.actor_name_snapshot || "System"}</span>
          {activity.source_label && <span>{activity.source_label}</span>}
          <time>{timeAgo(activity.created_at)}</time>
        </footer>
      </span>
    </button>
  );
}

export default function ActivityTimeline({ activities, onOpen }) {
  const groups = activities.reduce((acc, item) => {
    const key = groupKey(item.created_at);
    acc[key] = acc[key] || [];
    acc[key].push(item);
    return acc;
  }, {});

  return (
    <div className="activity-timeline">
      {Object.entries(groups).map(([group, rows]) => (
        <section key={group}>
          <h2>{group}</h2>
          {rows.map((activity) => (
            <ActivityRow key={activity.id} activity={activity} onOpen={onOpen} />
          ))}
        </section>
      ))}
    </div>
  );
}